import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import Langs from "../../../app/lang/langs";
import { showErrorToast, checkPermission } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config";
import { prefillPlanning, getPlanning } from "../planningSlice";

export function MobilePrefillModal({ show, onHide }) {
  const dispatch = useDispatch();

  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);
  const selectedDate = useSelector((state) => state.planning.selectedDate);
  const collabs = useSelector((state) => state.collabs.list);

  function isManager(teamId) {
    return checkPermission(config.scopes.shifts, config.permissionTypes.edit, teamId);
  }

  function handlePrefill() {
    if (!isManager(selectedTeamsIds[0])) return;
    dispatch(
      prefillPlanning({
        id_team: selectedTeamsIds[0],
        month: new Date(selectedDate).getMonth(),
        year: new Date(selectedDate).getFullYear(),
      })
    ).then((response) => {
      if (response["payload"]["responseData"]["status"] == 1) {
        loadPlanning();
      }
      if (response["payload"]["responseData"]["status"] == 4) {
        showErrorToast(response["payload"]["responseData"]["message"]);
      }
      if (response["payload"]["responseError"]) {
        showErrorToast();
      }
    });
    onHide();
  }

  function loadPlanning() {
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) => {
        array.push(current.id);
        return array;
      }, []);
      dispatch(getPlanning({ selectedTeamsIds, selectedCollabsIds }));
    }
  }

  return (
    <Dialog
      open={show}
      onClose={onHide}
      fullWidth
      maxWidth="xs"
      sx={{ zIndex: 1400 }}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          mx: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          pb: 1,
        }}
      >
        <AutoFixHighIcon sx={{ color: "#FF9015", fontSize: 28 }} />
        <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
          <Langs str="PREFILL" />
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ py: 1 }}>
          <Langs str="ARE_YOU_SURE_PREFILL" />
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onHide}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            color: "text.secondary",
            borderColor: "divider",
          }}
        >
          <Langs str="CANCEL" />
        </Button>
        <Button
          variant="contained"
          onClick={handlePrefill}
          sx={{
            flex: 1,
            borderRadius: "999px",
            minHeight: 48,
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#FF9015",
            "&:hover": { backgroundColor: "#e6820d" },
            "&:active": { transform: "scale(0.97)" },
          }}
        >
          <Langs str="YES" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
